import { Grid2, Typography, Alert, Link } from "@mui/material";
import "../App.css";
import { Box } from "@mui/material";
import { GoogleLogin } from "@react-oauth/google";
import { UserAPI } from "../apis/userApi";
import { useDispatch } from "react-redux";
import { setUser } from "../redux/userSlice";
import { useNavigate } from "react-router";
import { useState } from "react";
function SignIn() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const gridItemStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const signInUser = async () => {
    try {
      const u = await UserAPI.get();

      // TODO : here we can navigate user to their assignments tab if they have upcoming jobs

      dispatch(setUser(u));
      const redirectJob = localStorage.getItem("job-redirect");
      if (redirectJob) {
        window.history.pushState({ urlPath: "/jobs" }, "", "/jobs");
        navigate(`/jobs/${redirectJob}`);
        localStorage.setItem("job-redirect", "");
      } else {
        navigate("/");
      }
    } catch (e: any) {
      console.log(e);
      console.log(e.response.data.message);
      const errMsg = e.response.data.message;
      setShowAlert(true);
      if (errMsg === "Please sign up before logging in.") {
        setAlertMessage("User does not exist.");
      } else {
        setAlertMessage("Unknown login error.");
      }
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "30rem",
      }}
    >
      <Grid2 container spacing={5}>
        <Grid2 size={12} sx={gridItemStyle}>
          <Typography variant="h3">Sign in</Typography>
        </Grid2>

        <Grid2 size={12} sx={gridItemStyle}>
          <GoogleLogin
            text="signin_with"
            width="208px"
            onSuccess={(credentialResponse) => {
              localStorage.setItem("token_type", "google");
              localStorage.setItem(
                "token",
                credentialResponse.credential || ""
              );
              signInUser();
            }}
            onError={() => {
              alert("Login Failed");
            }}
          />
        </Grid2>
        {showAlert ? (
          <Grid2 size={12} sx={gridItemStyle}>
            <Alert severity="error">{alertMessage}</Alert>
          </Grid2>
        ) : null}
        <Grid2 size={12} sx={gridItemStyle}>
          New User? &nbsp;{" "}
          <Link
            onClick={() => {
              navigate("/sign-up");
            }}
          >
            Sign Up
          </Link>
        </Grid2>
      </Grid2>
    </Box>
  );
}

export default SignIn;
